import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';

const CHALLENGES = [
  {
    icon: 'schedule',
    title: '待ち時間',
    description: '5分超で50%離脱',
  },
  {
    icon: 'translate',
    title: '多言語対応',
    description: '通訳確保が困難',
  },
  {
    icon: 'dark_mode',
    title: '営業時間外',
    description: '24h対応は高コスト',
  },
  {
    icon: 'edit_note',
    title: 'FAQ更新',
    description: '運用負担が大きい',
  },
  {
    icon: 'payments',
    title: '導入コスト',
    description: '数百万円の初期投資',
  },
];

/**
 * ProblemsSection組件
 * 5大課題展示区域
 *
 * 展示5个常见的施設運営課題
 */
export const ProblemsSection: React.FC = () => {
  return (
    <div className="w-full px-4 md:px-10 lg:px-40 py-16 bg-gray-50">
      <div className="max-w-[1200px] w-full mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-solution-text">
            商業施設の案内業務でこんな課題はありませんか？
          </h2>
        </div>

        {/* Challenge Cards - Horizontal */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {CHALLENGES.map((challenge, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 text-center border border-gray-100 hover:border-solution-orange/30 hover:shadow-md transition-all"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
                <MaterialIcon name={challenge.icon} className="text-2xl text-gray-600" />
              </div>
              <p className="font-bold text-solution-text text-sm mb-1">{challenge.title}</p>
              <p className="text-xs text-solution-text-secondary">{challenge.description}</p>
            </div>
          ))}
        </div>

        {/* Solution Arrow */}
        <div className="mt-10 text-center">
          <div className="inline-flex flex-col items-center">
            <MaterialIcon name="keyboard_double_arrow_down" className="text-3xl text-solution-orange animate-bounce" />
            <a
              href="#core-features"
              className="mt-2 text-solution-orange font-bold hover:text-solution-orange-dark transition-colors"
            >
              GBase Supportがすべて解決
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemsSection;
